module.exports = __webpack_public_path__ + "img/part-4-title.e1b1db79.png";